<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-12 09:01:04
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-24 18:50:25
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/productEvaluationInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 我的产品质量评价上传资料 -->
<template>
  <div>
    <div class="form-container">
      <div class="form-title">我的产品评价</div>
      <eSteps :stepList="stepList" :isActive="isActive"></eSteps>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">订单信息</div>
      <orderInfo :applyInfo="applyInfo"></orderInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">评价信息</div>
      <evaluationInfo :applyId="applyId"></evaluationInfo>
    </div>
    <!--    v-if="-->
    <!--    routeFrom === 'myApplyPage' &&-->
    <!--    (applyStatus !== 217 || applyStatus !== 218 || applyStatus !== 219)-->
    <!--    "-->
    <div class="form-container">
      <div class="form-title margin-b-20">供应商信息</div>
      <supplierInfo
        :applyInfo="applyInfo"
        @changeConfirm="changeConfirm"
      ></supplierInfo>
    </div>

    <div class="btn-wrap">
      <eui-btn type="secondary" @click="goBack">返回</eui-btn>
      <eui-btn type="primary" v-debounce="submitApplyInfo" :disabled="!isUpload">提交</eui-btn>
    </div>
  </div>
</template>

<script>
import eSteps from '../../../components/common/e-steps.vue';
import evaluationInfo from './component/evaluationInfo.vue';
import orderInfo from './component/orderInfo.vue';
import supplierInfo from './component/supplierInfo.vue';
import api from '../../../api/evaluation/index';

export default {
  data() {
    return {
      isUpload: false, //供应商 信息 里面的 勾选
      isActive: 1,
      stepList: [
        {
          id: 1,
          title: '提交申请'
        },
        {
          id: 2,
          title: '确认申请'
        },
        {
          id: 3,
          title: '支付完成'
        },
        {
          id: 4,
          title: '审核通过'
        },
        {
          id: 5,
          title: '评价完成'
        }
      ],
      applyInfo: {},
      fromRoute: {},
      routeFrom: null,
      applyId: null,
      applyStatus: null
    };
  },

  components: {
    eSteps,
    evaluationInfo,
    orderInfo,
    supplierInfo
  },

  computed: {},

  created() {
    console.log(this.$route.query);
    this.applyId = Number(this.$route.query.applyId);
    this.routeFrom = this.$route.query.from;
    if (this.routeFrom === 'myApplyPage') {
      this.applyStatus = this.$route.query.applyStatus;
    }
    this.getEvaluationInfo(this.applyId);
  },
  methods: {
    changeConfirm(val) {
      console.log(val);
      this.isUpload = val;
    },
    //  评价申请人信息===========
    async getEvaluationInfo(applyId) {
      let res = await api.getEvaluationApplyDetail({ applyId: applyId });
      if (res.code === '200') {
        this.applyInfo = res.data;
      }
    },
    // 判断资料是否上传
    async checkUploadApplyMaterialInfo(params, callback) {
      let res = await api.checkEvaluationApplyMaterialInfo(params);
      if (res.code === '200') {
        callback(res);
      }
    },
    //  组装判断是否上传接口参数
    assemblyParams(arr) {
      if (arr.length === 0) return;
      let temArr = [];
      arr.forEach(item => {
        temArr.push({
          productName: item.productName,
          evaluationCode: item.evaluationCode
        });
      });
      return temArr;
    },
    async submitApplyInfo() {
      let params = this.assemblyParams(
        this.applyInfo.evaluationApplyItemPriceVOList
      );
      if (this.isUpload && this.applyStatus === '218') {
        this.checkUploadApplyMaterialInfo(
          { evaluationApplyItemPriceAOList: params, applyId: this.applyId },
          async res => {
            if (res.code === '200') {
              let data = await api.modifyStandardizedQualificationInfoSubmit({
                applyId: this.applyId
              });
              if (data.code === '200') {
                this.$routr.push({ path: '/ES/ESapply' });
              }
            }
          }
        );
      } else {
        this.$message.warning('请勾选');
      }
    },
    goBack() {
      this.$router.push({ path: '/ES/ESapply' });
    }
  }
};
</script>
<style lang="scss" scoped>
.margin-b-20 {
  margin-bottom: 20px;
}

.btn-wrap {
  text-align: center;
}
</style>
